import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const comparisonStringUiNodeSpec: UiNodeSpec<'comparisonString'> = {
    requiredSockets: () => ({
        conditionallyRequired: [],
        required: [ 'output', 'input1', 'input2' ],
    }),
    cfg: () => ({ controlValues: { not: false, operation: '=' }, id: getUID(), kind: 'comparisonString', disabled: false }),
    controls: getNodeCfg => ({
        not: { cfg: { kind: 'boolean', label: 'Not' }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.not },
        operation: {
            cfg: {
                items: [
                    { label: '=', value: '=' },
                    { label: 'contains', value: 'contains' },
                    { label: 'startsWith', value: 'startsWith' },
                    { label: 'endsWith', value: 'endsWith' },
                ],
                kind: 'selection',
                label: 'Operation',
            },
            nodeCfg: getNodeCfg(),
            value: getNodeCfg().controlValues.operation,
        },
    }),
    inputs: nodeCfg => ({
        input1: {
            control: {
                cfg: {
                    kind: 'text',
                    nullable: true,
                },
                nodeCfg,
                nullable: true,
                value: nodeCfg.socketDefaults?.inputs?.input1,
            },
            socket: 'string',
            label: 'Input 1',
        },
        input2: {
            control: {
                cfg: {
                    kind: 'text',
                    nullable: true,
                },
                nodeCfg,
                nullable: true,
                value: nodeCfg.socketDefaults?.inputs?.input2,
            },
            socket: 'string',
            label: 'Input 2',
        },
    }),
    kindLabel: 'Text Comparison',
    nodeCategory: 'conditional',
    outputs: () => ({ output: { socket: 'boolean', label: 'Output' } }),
    validator: () => true,
};
